import gql from 'graphql-tag';

export default gql`
subscription {
    onUpdateEtlQuery {
        __typename
        id
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/EtlQueries/UpdateSubscription.js